(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Delegated, so cards injected later (recommendations) hydrate too. */
    function hydrate(e) {
      var card = e.target && e.target.closest && e.target.closest('[data-card-hover]');
      if (!card) return;
      card.removeAttribute('data-card-hover');
      var img = card.querySelector('img[data-srcset]');
      if (!img) return;
      img.sizes = img.getAttribute('data-sizes') || '';
      img.srcset = img.getAttribute('data-srcset');
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-sizes');
    }
    document.addEventListener('mouseover', hydrate, { passive: true });
    document.addEventListener('focusin', hydrate);
  })();
  } catch(e) { console.error(e); }
})();

})();
